import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Box, Flex } from 'grid-styled';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

/*const chartData = {
  'Autonomie - ondersteuning': [
    { type: 'Participatief', value: 1, fill: am4core.color('#b4ff00') },
    { type: 'Afstemmend', value: 3, fill: am4core.color('#44cc02') }
  ],
  Structuur: [
    { type: 'Begeleidend', value: 5, fill: am4core.color('#fefdae') },
    { type: 'Verduidelijking', value: 2, fill: am4core.color('#ffde00') }
  ],
  Controlerend: [
    { type: 'Eisend', value: 4, fill: am4core.color('#ffab01') },
    { type: 'Dominerend', value: 5, fill: am4core.color('#ff6c01') }
  ],
  Chaos: [
    { type: 'Opgevend', value: 2, fill: am4core.color('#ff0100') },
    { type: 'Afwachtend', value: 4, fill: am4core.color('#cd1800') }
  ]
};*/

@inject('routing', 'authStore', 'uiState')
@observer
export default class ResultChart extends Component {
  componentDidMount() {
    const { data } = this.props;

    let chart = am4core.create('chartdiv', am4charts.RadarChart);
    chart.hiddenState.properties.opacity = 0;

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'type';
    categoryAxis.renderer.labels.template.location = 0.5;
    categoryAxis.renderer.labels.template.bent = true;
    categoryAxis.renderer.labels.template.radius = 5;
    categoryAxis.renderer.labels.template.fillOpacity = 1;
    categoryAxis.renderer.labels.template.fontSize = 14;

    this.categoryAxis = categoryAxis;

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 7;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.minGridDistance = 20;
    valueAxis.renderer.grid.template.location = 0;
    valueAxis.renderer.labels.template.fillOpacity = 0;

    let series = chart.series.push(new am4charts.RadarColumnSeries());
    series.dataFields.valueY = 'value';
    series.dataFields.categoryX = 'type';
    series.alignLabels = false;
    series.strokeWidth = 0;
    series.columns.template.tooltipText =
      'Category: {categoryX}\nValue: {valueY}';
    series.columns.template.width = am4core.percent(100);

    series.columns.template.column.adapter.add('fill', (fill, target) => {
      const color = /#(?:[a-f0-9]{3}|[a-f0-9]{6})\b/.exec(
        target.dataItem.dataContext.fill
      );
      return color[0];
    });

    chart.data = this.generateRadarData(data);

    this.chart = chart;
  }
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  generateRadarData(chartData) {
    let data = [];
    let i = 0;

    const catArray = ['Autonomie - ondersteuning', 'Structuur', 'Controlerend', 'Chaos' ];
    const types = [];
    catArray.forEach(cat => {
      let typeData = chartData[cat];
      types[catArray.indexOf(cat)] = typeData;
      typeData.forEach(type => {
        this.createTypeRange(type);
      });
      this.createCategoryRange(cat, typeData, i);
      i++;
    })

    return types.flat();
  }

  createTypeRange(type) {
    let axisRange = this.categoryAxis.axisRanges.create();
    axisRange.axisFill.interactionsEnabled = true;
    axisRange.category = type.type;
    axisRange.endCategory = type.type;
    axisRange.grid.disabled = true;
    axisRange.label.interactionsEnabled = false;
    axisRange.label.bent = true;
    axisRange.label.fontSize = 14;
    axisRange.label.stroke = 'red';
    axisRange.label.fontSize = 0;
    axisRange.label.opacity = 0;

    const color = /#(?:[a-f0-9]{3}|[a-f0-9]{6})\b/.exec(type.fill);

    let axisFill = axisRange.axisFill;
    axisFill.innerRadius = am4core.percent(100);
    axisFill.radius = -28;
    axisFill.disabled = false; // as regular fills are disabled, we need to enable this one
    axisFill.fillOpacity = 1;
    axisFill.fill = am4core.color(color[0]);
    axisFill.stroke = '#999';
  }

  createCategoryRange(category, typeData, i) {
    let axisRange = this.categoryAxis.axisRanges.create();
    axisRange.axisFill.interactionsEnabled = true;
    axisRange.text = category;
    axisRange.category = typeData[0].type;
    axisRange.endCategory = typeData[typeData.length - 1].type;
    axisRange.grid.disabled = true;
    axisRange.label.interactionsEnabled = false;
    axisRange.label.bent = true;

    let axisFill = axisRange.axisFill;
    axisFill.innerRadius = am4core.percent(115);
    axisFill.radius = -60;
    axisFill.disabled = false; // as regular fills are disabled, we need to enable this one
    axisFill.fillOpacity = 0;
    axisFill.stroke = '#999';

    let axisLabel = axisRange.label;
    axisLabel.location = 0.5;
    axisLabel.fill = am4core.color('#000');
    axisLabel.radius = 40;
    axisLabel.relativeRotation = 0;
    axisLabel.fontSize = 14;
  }

  render() {
    return (
      <Flex flexWrap="wrap" width={1 / 1}>
        <div
          id="chartdiv"
          style={{
            width: '100%',
            height: '500px',
            position: 'relative',
            transform: 'scale(0.8)',

            marginTop: -50
          }}
        />
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/discover/components/ResultChart.js